import React from 'react'
import { motion } from 'framer-motion'
import Button3D from './Button3D'

export default function WorkCard({ card }) {
	return (
		<motion.div
			layout
			animate={{ opacity: 1, scale: 1 }}
			initial={{ opacity: 0, scale: 0 }}
			exit={{ opacity: 0, scale: 0 }}
			className='work__card'
		>
			<div className='workCard__grid'>
				<img
					src={card.route}
					alt=''
					className='work__img'
					filter={card.filter}
				/>

				<div className='workCard__container'>
					<div>
						<h3 className='work__title'>{card.title}</h3>
						<a
							target='_blank'
							rel='noreferrer'
							href={card.demo}
							className='work__button'
						>
							Demo
							<i className='bx bx-right-arrow-alt work__icon'></i>
						</a>
					</div>
					{card.href && (
						<Button3D
							props={{
								content: <i className='bx bxl-github buttonIcon'></i>,
								style: { opacity: 1, padding: '0.25rem' },
								href: card.href,
								target: '_blank',
							}}
						/>
					)}
				</div>
			</div>
		</motion.div>
	)
}
